import { render, staticRenderFns } from "./SfBullets.vue?vue&type=template&id=123c08da&"
import script from "./SfBullets.vue?vue&type=script&lang=js&"
export * from "./SfBullets.vue?vue&type=script&lang=js&"
import style0 from "./SfBullets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports